const initialState = {
  amenityList: null,
  amenityById: null,
};

const amenityReducer = (state = initialState, action) => {
  switch (action.type) {
    case "GET_ALL_AMENITIES":
      return {
        ...state,
        amenityList: action.data,
      };
    case "GET_AMENITY_BY_ID":
      return {
        ...state,
        amenityById: action.data,
      };
    case "ADD_AMENITY":
      return {
        ...state,
      };
    case "UPDATE_AMENITY_BY_ID":
      return {
        ...state,
      };
    default:
      return state;
  }
};

export default amenityReducer;
